/* tslint:disable */
/* eslint-disable */
/**
 * NK Solution Core API
 * OpenAPI backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AnalysesClaimsPost200Response
 */
export interface AnalysesClaimsPost200Response {
    /**
     * 
     * @type {string}
     * @memberof AnalysesClaimsPost200Response
     */
    'message'?: string | null;
    /**
     * 
     * @type {Array<AnalysesClaimsPost200ResponseClaimsInner>}
     * @memberof AnalysesClaimsPost200Response
     */
    'claims'?: Array<AnalysesClaimsPost200ResponseClaimsInner>;
    /**
     * 
     * @type {string}
     * @memberof AnalysesClaimsPost200Response
     */
    'conclusion'?: string | null;
}
/**
 * 
 * @export
 * @interface AnalysesClaimsPost200ResponseClaimsInner
 */
export interface AnalysesClaimsPost200ResponseClaimsInner {
    /**
     * 
     * @type {string}
     * @memberof AnalysesClaimsPost200ResponseClaimsInner
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysesClaimsPost200ResponseClaimsInner
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysesClaimsPost200ResponseClaimsInner
     */
    'analysis'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AnalysesClaimsPost200ResponseClaimsInner
     */
    'valid'?: boolean;
}
/**
 * 
 * @export
 * @interface AnalysesClaimsPost401Response
 */
export interface AnalysesClaimsPost401Response {
    /**
     * 
     * @type {string}
     * @memberof AnalysesClaimsPost401Response
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface AnalysesClaimsPostRequest
 */
export interface AnalysesClaimsPostRequest {
    /**
     * 
     * @type {Array<AnalysesClaimsPostRequestClaimsInner>}
     * @memberof AnalysesClaimsPostRequest
     */
    'claims'?: Array<AnalysesClaimsPostRequestClaimsInner>;
}
/**
 * @type AnalysesClaimsPostRequestClaimsInner
 * @export
 */
export type AnalysesClaimsPostRequestClaimsInner = Claim | string;

/**
 * 
 * @export
 * @interface AnalysesInvoicesPost200Response
 */
export interface AnalysesInvoicesPost200Response {
    /**
     * 
     * @type {string}
     * @memberof AnalysesInvoicesPost200Response
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnalysesInvoicesPost200Response
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysesInvoicesPost200Response
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysesInvoicesPost200Response
     */
    'category'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysesInvoicesPost200Response
     */
    'currencyCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysesInvoicesPost200Response
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof AnalysesInvoicesPost200Response
     */
    'date'?: string | null;
}
/**
 * 
 * @export
 * @interface AnalysesInvoicesPost400Response
 */
export interface AnalysesInvoicesPost400Response {
    /**
     * 
     * @type {string}
     * @memberof AnalysesInvoicesPost400Response
     */
    'message'?: string | null;
}
/**
 * 
 * @export
 * @interface AnalysesQuotesPost200Response
 */
export interface AnalysesQuotesPost200Response {
    /**
     * 
     * @type {AnalysesQuotesPost200ResponseQuote}
     * @memberof AnalysesQuotesPost200Response
     */
    'quote'?: AnalysesQuotesPost200ResponseQuote;
}
/**
 * 
 * @export
 * @interface AnalysesQuotesPost200ResponseQuote
 */
export interface AnalysesQuotesPost200ResponseQuote {
    /**
     * 
     * @type {string}
     * @memberof AnalysesQuotesPost200ResponseQuote
     */
    'address_line_1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysesQuotesPost200ResponseQuote
     */
    'address_line_2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysesQuotesPost200ResponseQuote
     */
    'address_line_3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysesQuotesPost200ResponseQuote
     */
    'agent_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysesQuotesPost200ResponseQuote
     */
    'business_registration_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysesQuotesPost200ResponseQuote
     */
    'chassis_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysesQuotesPost200ResponseQuote
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysesQuotesPost200ResponseQuote
     */
    'gross_premium'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysesQuotesPost200ResponseQuote
     */
    'id_type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysesQuotesPost200ResponseQuote
     */
    'make_and_model_of_vehicle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysesQuotesPost200ResponseQuote
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysesQuotesPost200ResponseQuote
     */
    'ncd'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysesQuotesPost200ResponseQuote
     */
    'ocr_confidence_score'?: number;
    /**
     * 
     * @type {string}
     * @memberof AnalysesQuotesPost200ResponseQuote
     */
    'period_of_insurance_from'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysesQuotesPost200ResponseQuote
     */
    'period_of_insurance_to'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysesQuotesPost200ResponseQuote
     */
    'policy_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysesQuotesPost200ResponseQuote
     */
    'quotation_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysesQuotesPost200ResponseQuote
     */
    'quotation_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysesQuotesPost200ResponseQuote
     */
    'quotation_valid_until'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysesQuotesPost200ResponseQuote
     */
    'service_tax'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysesQuotesPost200ResponseQuote
     */
    'special_perils'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysesQuotesPost200ResponseQuote
     */
    'stamp_duty'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysesQuotesPost200ResponseQuote
     */
    'sum_insured'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysesQuotesPost200ResponseQuote
     */
    'telephone_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysesQuotesPost200ResponseQuote
     */
    'total_payable'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysesQuotesPost200ResponseQuote
     */
    'vehicale_registration_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysesQuotesPost200ResponseQuote
     */
    'windscreen'?: string | null;
}
/**
 * 
 * @export
 * @interface Claim
 */
export interface Claim {
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof Claim
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'currencyCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'date'?: string;
    /**
     * 
     * @type {ClaimSubmission}
     * @memberof Claim
     */
    'submission'?: ClaimSubmission;
}
/**
 * 
 * @export
 * @interface ClaimSubmission
 */
export interface ClaimSubmission {
    /**
     * 
     * @type {string}
     * @memberof ClaimSubmission
     */
    'timestamp'?: string;
}
/**
 * 
 * @export
 * @interface ExpensesExportsPostRequest
 */
export interface ExpensesExportsPostRequest {
    /**
     * 
     * @type {Array<string | null>}
     * @memberof ExpensesExportsPostRequest
     */
    'claims'?: Array<string | null>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Role = {
    Admin: 'admin',
    Dev: 'dev',
    OrgUser: 'orgUser',
    OrgAdmin: 'orgAdmin',
    OrgFinance: 'orgFinance'
} as const;

export type Role = typeof Role[keyof typeof Role];


/**
 * 
 * @export
 * @interface ThreadsPost200Response
 */
export interface ThreadsPost200Response {
    /**
     * 
     * @type {string}
     * @memberof ThreadsPost200Response
     */
    'message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ThreadsPost200Response
     */
    'threadId'?: string | null;
}
/**
 * 
 * @export
 * @interface ThreadsPostRequest
 */
export interface ThreadsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ThreadsPostRequest
     */
    'topic': ThreadsPostRequestTopicEnum;
}

export const ThreadsPostRequestTopicEnum = {
    Product: 'product'
} as const;

export type ThreadsPostRequestTopicEnum = typeof ThreadsPostRequestTopicEnum[keyof typeof ThreadsPostRequestTopicEnum];

/**
 * 
 * @export
 * @interface ThreadsThreadIdActionsPost200Response
 */
export interface ThreadsThreadIdActionsPost200Response {
    /**
     * 
     * @type {string}
     * @memberof ThreadsThreadIdActionsPost200Response
     */
    'message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ThreadsThreadIdActionsPost200Response
     */
    'reply'?: string | null;
}
/**
 * 
 * @export
 * @interface ThreadsThreadIdActionsPostRequest
 */
export interface ThreadsThreadIdActionsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ThreadsThreadIdActionsPostRequest
     */
    'runId': string | null;
    /**
     * 
     * @type {Array<ThreadsThreadIdActionsPostRequestToolOutputsInner>}
     * @memberof ThreadsThreadIdActionsPostRequest
     */
    'toolOutputs': Array<ThreadsThreadIdActionsPostRequestToolOutputsInner>;
}
/**
 * 
 * @export
 * @interface ThreadsThreadIdActionsPostRequestToolOutputsInner
 */
export interface ThreadsThreadIdActionsPostRequestToolOutputsInner {
    /**
     * 
     * @type {string}
     * @memberof ThreadsThreadIdActionsPostRequestToolOutputsInner
     */
    'output': string | null;
    /**
     * 
     * @type {string}
     * @memberof ThreadsThreadIdActionsPostRequestToolOutputsInner
     */
    'tool_call_id': string | null;
}
/**
 * 
 * @export
 * @interface ThreadsThreadIdMessagesPost200Response
 */
export interface ThreadsThreadIdMessagesPost200Response {
    /**
     * 
     * @type {string}
     * @memberof ThreadsThreadIdMessagesPost200Response
     */
    'message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ThreadsThreadIdMessagesPost200Response
     */
    'reply'?: string | null;
    /**
     * 
     * @type {ThreadsThreadIdMessagesPost200ResponseAction}
     * @memberof ThreadsThreadIdMessagesPost200Response
     */
    'action'?: ThreadsThreadIdMessagesPost200ResponseAction;
}
/**
 * 
 * @export
 * @interface ThreadsThreadIdMessagesPost200ResponseAction
 */
export interface ThreadsThreadIdMessagesPost200ResponseAction {
    /**
     * 
     * @type {string}
     * @memberof ThreadsThreadIdMessagesPost200ResponseAction
     */
    'runId': string | null;
    /**
     * 
     * @type {Array<ThreadsThreadIdMessagesPost200ResponseActionToolCallsInner>}
     * @memberof ThreadsThreadIdMessagesPost200ResponseAction
     */
    'toolCalls': Array<ThreadsThreadIdMessagesPost200ResponseActionToolCallsInner>;
}
/**
 * 
 * @export
 * @interface ThreadsThreadIdMessagesPost200ResponseActionToolCallsInner
 */
export interface ThreadsThreadIdMessagesPost200ResponseActionToolCallsInner {
    /**
     * 
     * @type {string}
     * @memberof ThreadsThreadIdMessagesPost200ResponseActionToolCallsInner
     */
    'id': string | null;
    /**
     * 
     * @type {ThreadsThreadIdMessagesPost200ResponseActionToolCallsInnerFunction}
     * @memberof ThreadsThreadIdMessagesPost200ResponseActionToolCallsInner
     */
    'function': ThreadsThreadIdMessagesPost200ResponseActionToolCallsInnerFunction;
    /**
     * 
     * @type {string}
     * @memberof ThreadsThreadIdMessagesPost200ResponseActionToolCallsInner
     */
    'type': string | null;
}
/**
 * 
 * @export
 * @interface ThreadsThreadIdMessagesPost200ResponseActionToolCallsInnerFunction
 */
export interface ThreadsThreadIdMessagesPost200ResponseActionToolCallsInnerFunction {
    /**
     * 
     * @type {string}
     * @memberof ThreadsThreadIdMessagesPost200ResponseActionToolCallsInnerFunction
     */
    'arguments': string | null;
    /**
     * 
     * @type {string}
     * @memberof ThreadsThreadIdMessagesPost200ResponseActionToolCallsInnerFunction
     */
    'name': string | null;
}
/**
 * 
 * @export
 * @interface ThreadsThreadIdMessagesPostRequest
 */
export interface ThreadsThreadIdMessagesPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ThreadsThreadIdMessagesPostRequest
     */
    'content': string | null;
}
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'uid': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'displayName'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'photoURL'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'disabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'oid'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'lastActive'?: string;
}
/**
 * 
 * @export
 * @interface UsersGetRequest
 */
export interface UsersGetRequest {
    /**
     * 
     * @type {Array<string | null>}
     * @memberof UsersGetRequest
     */
    'ids'?: Array<string | null>;
}
/**
 * 
 * @export
 * @interface UsersUidPatchRequest
 */
export interface UsersUidPatchRequest {
    /**
     * 
     * @type {Array<Role>}
     * @memberof UsersUidPatchRequest
     */
    'roles'?: Array<Role>;
    /**
     * 
     * @type {string}
     * @memberof UsersUidPatchRequest
     */
    'lineManager'?: string | null;
}

/**
 * AnalysisApi - axios parameter creator
 * @export
 */
export const AnalysisApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Analyse expense claims validity
         * @param {AnalysesClaimsPostRequest} analysesClaimsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analysesClaimsPost: async (analysesClaimsPostRequest: AnalysesClaimsPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysesClaimsPostRequest' is not null or undefined
            assertParamExists('analysesClaimsPost', 'analysesClaimsPostRequest', analysesClaimsPostRequest)
            const localVarPath = `/analyses/claims`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-nk-api-key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(analysesClaimsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Analyse an invoice file
         * @param {File} file File to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analysesInvoicesPost: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('analysesInvoicesPost', 'file', file)
            const localVarPath = `/analyses/invoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-nk-api-key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Analyse a quote file
         * @param {File} file File to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analysesQuotesPost: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('analysesQuotesPost', 'file', file)
            const localVarPath = `/analyses/quotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-nk-api-key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnalysisApi - functional programming interface
 * @export
 */
export const AnalysisApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnalysisApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Analyse expense claims validity
         * @param {AnalysesClaimsPostRequest} analysesClaimsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analysesClaimsPost(analysesClaimsPostRequest: AnalysesClaimsPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnalysesClaimsPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analysesClaimsPost(analysesClaimsPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.analysesClaimsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Analyse an invoice file
         * @param {File} file File to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analysesInvoicesPost(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnalysesInvoicesPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analysesInvoicesPost(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.analysesInvoicesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Analyse a quote file
         * @param {File} file File to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analysesQuotesPost(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnalysesQuotesPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analysesQuotesPost(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.analysesQuotesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AnalysisApi - factory interface
 * @export
 */
export const AnalysisApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnalysisApiFp(configuration)
    return {
        /**
         * 
         * @summary Analyse expense claims validity
         * @param {AnalysesClaimsPostRequest} analysesClaimsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analysesClaimsPost(analysesClaimsPostRequest: AnalysesClaimsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AnalysesClaimsPost200Response> {
            return localVarFp.analysesClaimsPost(analysesClaimsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Analyse an invoice file
         * @param {File} file File to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analysesInvoicesPost(file: File, options?: RawAxiosRequestConfig): AxiosPromise<AnalysesInvoicesPost200Response> {
            return localVarFp.analysesInvoicesPost(file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Analyse a quote file
         * @param {File} file File to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analysesQuotesPost(file: File, options?: RawAxiosRequestConfig): AxiosPromise<AnalysesQuotesPost200Response> {
            return localVarFp.analysesQuotesPost(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnalysisApi - object-oriented interface
 * @export
 * @class AnalysisApi
 * @extends {BaseAPI}
 */
export class AnalysisApi extends BaseAPI {
    /**
     * 
     * @summary Analyse expense claims validity
     * @param {AnalysesClaimsPostRequest} analysesClaimsPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public analysesClaimsPost(analysesClaimsPostRequest: AnalysesClaimsPostRequest, options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).analysesClaimsPost(analysesClaimsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Analyse an invoice file
     * @param {File} file File to upload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public analysesInvoicesPost(file: File, options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).analysesInvoicesPost(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Analyse a quote file
     * @param {File} file File to upload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public analysesQuotesPost(file: File, options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).analysesQuotesPost(file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AssistantApi - axios parameter creator
 * @export
 */
export const AssistantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new thread
         * @param {ThreadsPostRequest} threadsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threadsPost: async (threadsPostRequest: ThreadsPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'threadsPostRequest' is not null or undefined
            assertParamExists('threadsPost', 'threadsPostRequest', threadsPostRequest)
            const localVarPath = `/threads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-nk-api-key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(threadsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send function call results to a thread
         * @param {string} threadId 
         * @param {ThreadsThreadIdActionsPostRequest} threadsThreadIdActionsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threadsThreadIdActionsPost: async (threadId: string, threadsThreadIdActionsPostRequest: ThreadsThreadIdActionsPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('threadsThreadIdActionsPost', 'threadId', threadId)
            // verify required parameter 'threadsThreadIdActionsPostRequest' is not null or undefined
            assertParamExists('threadsThreadIdActionsPost', 'threadsThreadIdActionsPostRequest', threadsThreadIdActionsPostRequest)
            const localVarPath = `/threads/{threadId}/actions`
                .replace(`{${"threadId"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-nk-api-key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(threadsThreadIdActionsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send a message to a thread
         * @param {string | null} threadId 
         * @param {ThreadsThreadIdMessagesPostRequest} threadsThreadIdMessagesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threadsThreadIdMessagesPost: async (threadId: string | null, threadsThreadIdMessagesPostRequest: ThreadsThreadIdMessagesPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('threadsThreadIdMessagesPost', 'threadId', threadId)
            // verify required parameter 'threadsThreadIdMessagesPostRequest' is not null or undefined
            assertParamExists('threadsThreadIdMessagesPost', 'threadsThreadIdMessagesPostRequest', threadsThreadIdMessagesPostRequest)
            const localVarPath = `/threads/{threadId}/messages`
                .replace(`{${"threadId"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-nk-api-key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(threadsThreadIdMessagesPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssistantApi - functional programming interface
 * @export
 */
export const AssistantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssistantApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new thread
         * @param {ThreadsPostRequest} threadsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async threadsPost(threadsPostRequest: ThreadsPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThreadsPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.threadsPost(threadsPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApi.threadsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send function call results to a thread
         * @param {string} threadId 
         * @param {ThreadsThreadIdActionsPostRequest} threadsThreadIdActionsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async threadsThreadIdActionsPost(threadId: string, threadsThreadIdActionsPostRequest: ThreadsThreadIdActionsPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThreadsThreadIdActionsPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.threadsThreadIdActionsPost(threadId, threadsThreadIdActionsPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApi.threadsThreadIdActionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send a message to a thread
         * @param {string | null} threadId 
         * @param {ThreadsThreadIdMessagesPostRequest} threadsThreadIdMessagesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async threadsThreadIdMessagesPost(threadId: string | null, threadsThreadIdMessagesPostRequest: ThreadsThreadIdMessagesPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThreadsThreadIdMessagesPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.threadsThreadIdMessagesPost(threadId, threadsThreadIdMessagesPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApi.threadsThreadIdMessagesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AssistantApi - factory interface
 * @export
 */
export const AssistantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssistantApiFp(configuration)
    return {
        /**
         * Create a new thread
         * @param {ThreadsPostRequest} threadsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threadsPost(threadsPostRequest: ThreadsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ThreadsPost200Response> {
            return localVarFp.threadsPost(threadsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Send function call results to a thread
         * @param {string} threadId 
         * @param {ThreadsThreadIdActionsPostRequest} threadsThreadIdActionsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threadsThreadIdActionsPost(threadId: string, threadsThreadIdActionsPostRequest: ThreadsThreadIdActionsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ThreadsThreadIdActionsPost200Response> {
            return localVarFp.threadsThreadIdActionsPost(threadId, threadsThreadIdActionsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Send a message to a thread
         * @param {string | null} threadId 
         * @param {ThreadsThreadIdMessagesPostRequest} threadsThreadIdMessagesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threadsThreadIdMessagesPost(threadId: string | null, threadsThreadIdMessagesPostRequest: ThreadsThreadIdMessagesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ThreadsThreadIdMessagesPost200Response> {
            return localVarFp.threadsThreadIdMessagesPost(threadId, threadsThreadIdMessagesPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AssistantApi - object-oriented interface
 * @export
 * @class AssistantApi
 * @extends {BaseAPI}
 */
export class AssistantApi extends BaseAPI {
    /**
     * Create a new thread
     * @param {ThreadsPostRequest} threadsPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssistantApi
     */
    public threadsPost(threadsPostRequest: ThreadsPostRequest, options?: RawAxiosRequestConfig) {
        return AssistantApiFp(this.configuration).threadsPost(threadsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send function call results to a thread
     * @param {string} threadId 
     * @param {ThreadsThreadIdActionsPostRequest} threadsThreadIdActionsPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssistantApi
     */
    public threadsThreadIdActionsPost(threadId: string, threadsThreadIdActionsPostRequest: ThreadsThreadIdActionsPostRequest, options?: RawAxiosRequestConfig) {
        return AssistantApiFp(this.configuration).threadsThreadIdActionsPost(threadId, threadsThreadIdActionsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send a message to a thread
     * @param {string | null} threadId 
     * @param {ThreadsThreadIdMessagesPostRequest} threadsThreadIdMessagesPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssistantApi
     */
    public threadsThreadIdMessagesPost(threadId: string | null, threadsThreadIdMessagesPostRequest: ThreadsThreadIdMessagesPostRequest, options?: RawAxiosRequestConfig) {
        return AssistantApiFp(this.configuration).threadsThreadIdMessagesPost(threadId, threadsThreadIdMessagesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExpenseApi - axios parameter creator
 * @export
 */
export const ExpenseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Submit an expense claim for approval
         * @param {string | null} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expensesClaimsIdSubmissionPost: async (id: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('expensesClaimsIdSubmissionPost', 'id', id)
            const localVarPath = `/expenses/claims/{id}/submission`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-nk-api-key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload an invoice file to create an expense claim
         * @param {File} file File to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expensesClaimsPost: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('expensesClaimsPost', 'file', file)
            const localVarPath = `/expenses/claims`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-nk-api-key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export expense claim
         * @param {ExpensesExportsPostRequest} expensesExportsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expensesExportsPost: async (expensesExportsPostRequest: ExpensesExportsPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'expensesExportsPostRequest' is not null or undefined
            assertParamExists('expensesExportsPost', 'expensesExportsPostRequest', expensesExportsPostRequest)
            const localVarPath = `/expenses/exports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-nk-api-key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(expensesExportsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExpenseApi - functional programming interface
 * @export
 */
export const ExpenseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExpenseApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Submit an expense claim for approval
         * @param {string | null} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async expensesClaimsIdSubmissionPost(id: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Claim>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.expensesClaimsIdSubmissionPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExpenseApi.expensesClaimsIdSubmissionPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload an invoice file to create an expense claim
         * @param {File} file File to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async expensesClaimsPost(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnalysesInvoicesPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.expensesClaimsPost(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExpenseApi.expensesClaimsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export expense claim
         * @param {ExpensesExportsPostRequest} expensesExportsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async expensesExportsPost(expensesExportsPostRequest: ExpensesExportsPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnalysesInvoicesPost400Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.expensesExportsPost(expensesExportsPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExpenseApi.expensesExportsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExpenseApi - factory interface
 * @export
 */
export const ExpenseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExpenseApiFp(configuration)
    return {
        /**
         * 
         * @summary Submit an expense claim for approval
         * @param {string | null} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expensesClaimsIdSubmissionPost(id: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Claim> {
            return localVarFp.expensesClaimsIdSubmissionPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload an invoice file to create an expense claim
         * @param {File} file File to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expensesClaimsPost(file: File, options?: RawAxiosRequestConfig): AxiosPromise<AnalysesInvoicesPost200Response> {
            return localVarFp.expensesClaimsPost(file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export expense claim
         * @param {ExpensesExportsPostRequest} expensesExportsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expensesExportsPost(expensesExportsPostRequest: ExpensesExportsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AnalysesInvoicesPost400Response> {
            return localVarFp.expensesExportsPost(expensesExportsPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExpenseApi - object-oriented interface
 * @export
 * @class ExpenseApi
 * @extends {BaseAPI}
 */
export class ExpenseApi extends BaseAPI {
    /**
     * 
     * @summary Submit an expense claim for approval
     * @param {string | null} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpenseApi
     */
    public expensesClaimsIdSubmissionPost(id: string | null, options?: RawAxiosRequestConfig) {
        return ExpenseApiFp(this.configuration).expensesClaimsIdSubmissionPost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload an invoice file to create an expense claim
     * @param {File} file File to upload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpenseApi
     */
    public expensesClaimsPost(file: File, options?: RawAxiosRequestConfig) {
        return ExpenseApiFp(this.configuration).expensesClaimsPost(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export expense claim
     * @param {ExpensesExportsPostRequest} expensesExportsPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpenseApi
     */
    public expensesExportsPost(expensesExportsPostRequest: ExpensesExportsPostRequest, options?: RawAxiosRequestConfig) {
        return ExpenseApiFp(this.configuration).expensesExportsPost(expensesExportsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns a list of users.
         * @param {string | null} [email] Filter users by email
         * @param {string | null} [startAfter] Start listing users from the user after this uid
         * @param {UsersGetRequest} [usersGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersGet: async (email?: string | null, startAfter?: string | null, usersGetRequest?: UsersGetRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-nk-api-key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(usersGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a user by uid.
         * @param {string | null} uid 
         * @param {UsersUidPatchRequest} usersUidPatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUidPatch: async (uid: string | null, usersUidPatchRequest: UsersUidPatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('usersUidPatch', 'uid', uid)
            // verify required parameter 'usersUidPatchRequest' is not null or undefined
            assertParamExists('usersUidPatch', 'usersUidPatchRequest', usersUidPatchRequest)
            const localVarPath = `/users/{uid}`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-nk-api-key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(usersUidPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns a list of users.
         * @param {string | null} [email] Filter users by email
         * @param {string | null} [startAfter] Start listing users from the user after this uid
         * @param {UsersGetRequest} [usersGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersGet(email?: string | null, startAfter?: string | null, usersGetRequest?: UsersGetRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<User>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersGet(email, startAfter, usersGetRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.usersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a user by uid.
         * @param {string | null} uid 
         * @param {UsersUidPatchRequest} usersUidPatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersUidPatch(uid: string | null, usersUidPatchRequest: UsersUidPatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersUidPatch(uid, usersUidPatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.usersUidPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns a list of users.
         * @param {string | null} [email] Filter users by email
         * @param {string | null} [startAfter] Start listing users from the user after this uid
         * @param {UsersGetRequest} [usersGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersGet(email?: string | null, startAfter?: string | null, usersGetRequest?: UsersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<User>> {
            return localVarFp.usersGet(email, startAfter, usersGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a user by uid.
         * @param {string | null} uid 
         * @param {UsersUidPatchRequest} usersUidPatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUidPatch(uid: string | null, usersUidPatchRequest: UsersUidPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.usersUidPatch(uid, usersUidPatchRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 
     * @summary Returns a list of users.
     * @param {string | null} [email] Filter users by email
     * @param {string | null} [startAfter] Start listing users from the user after this uid
     * @param {UsersGetRequest} [usersGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public usersGet(email?: string | null, startAfter?: string | null, usersGetRequest?: UsersGetRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).usersGet(email, startAfter, usersGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a user by uid.
     * @param {string | null} uid 
     * @param {UsersUidPatchRequest} usersUidPatchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public usersUidPatch(uid: string | null, usersUidPatchRequest: UsersUidPatchRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).usersUidPatch(uid, usersUidPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



